var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-supsis-business-primary-location-country-update" },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v("Whatsapp Business API V2 birincil konum ülkesi güncellendi"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "meta" }, [
        _c("div", [
          _c("b", [_vm._v("Event")]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.event"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Kanal ID")]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("b", [_vm._v("Ülke")]),
          _vm._v(": " + _vm._s(_vm.$_.get(_vm.activity, "payload.country"))),
        ]),
      ]),
      _vm._v(" "),
      _c("details", { staticClass: "raw" }, [
        _c("summary", [_vm._v("Ham payload")]),
        _vm._v(" "),
        _c("pre", [_vm._v(_vm._s(_vm.prettyPayload))]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }